import { autoScrollForElements } from '@atlaskit/pragmatic-drag-and-drop-auto-scroll/element'
import { useEffect } from 'react'

/**
 * useAutoScroll Hook
 *
 * A custom hook that enables automatic scrolling when dragging elements near
 * the edges of the viewport. This improves the user experience when dragging
 * candidates between columns that may be off-screen.
 *
 * Features:
 * - Automatically scrolls the page when dragging near viewport edges
 * - Works with the document root element
 * - Cleans up on unmount
 *
 * The auto-scroll is handled by Pragmatic Drag and Drop's auto-scroll addon,
 * which provides smooth, performant scrolling behavior.
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   // Enable auto-scroll for the entire page
 *   useAutoScroll();
 *
 *   return <div>...</div>;
 * }
 * ```
 */
export function useAutoScroll(): void {
	useEffect(() => {
		// Setup auto-scroll for the document element
		// This allows scrolling when dragging near the edges of the viewport
		return autoScrollForElements({
			element: document.documentElement,
		})
	}, [])
}
